import React, { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../model/hooks'
import { getToken } from '../../../model/tokens/helper'
import { useWalletContext } from '../../WalletContext'
import { getAllCLPools, getCLPool } from '../../../model/clpool/helper'
import { Network } from '../../../services/token.service'
import { CLPool } from '../../../atoms'
import { getCurrentRatio, getCurrentTick } from '../../../services/amm_v3'
import { calculateRatioFromTickForTokens, formatFloatingPointNumber, formatNumber, getFeeMultiplierDivider, normalizeForTokens, numFormat } from '../../../blockchainUtils/math'
import { apiUrl, getTokenBraavosName } from '../../../blockchainUtils'
import PrimaryButton from '../../PrimaryButton'
import RemoveLiquidity from '../../RemoveLiquidity'
import { BackIcon } from '../../../svgIcons/BackIcon'
import AddLiquidity from '../../AddLiquidity'
import { collectFees } from '../../../services/position'
import { GAtrack } from '../../../services/ga'
import BigNumber from 'bignumber.js'
import { usePrevious } from '../../../hooks/usePrevious'
import { CLPosition } from '../../../model/clpool'
import { AlertIcon } from '../../../svgIcons/AlertIcon'
import { HelptipIcon } from '../../../svgIcons/HelptipIcon'
import { CircleIcon } from '../../../svgIcons/CircleIcon'
import RebalancePopup from '../../RebalancePopup/RebalancePopup'
import { calculateTotalLiquidityUsdPerPosition, getPercentageOfLiquidityForPosition } from '../../../blockchainUtils/positionAmountsMath'
import Spinner from '../../Spinner'
import RangeSliderSelector from '../RangeSliderSelector/RangeSliderSelector'
import Footer from '../../Footer/Footer'
import Header from '../../Header/Header'
import { pageStyle, pageStyleMobile } from '../../Main'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Popup from '../../Popup'
import { MAX_TICK } from '../helper'

function PositionPage() {
    let [searchParams, setSearchParams] = useSearchParams()
    const { walletAddress: connectedAddress, networkName: network, connect } = useWalletContext()
    const [positionIndex, setPositionIndex] = useState(undefined as unknown as number)
    const clPosition = useStoreState((state) => state.clPools.getCLPositionByIndex(network!, positionIndex))
    const [selectedPool, setSelectedPool] = useState(undefined as unknown as CLPool)
    const [currentRatio, setCurrentRatio] = useState('0')
    const [isRange1, setIsRange1] = useState<boolean | undefined>(undefined)
    const [isCollectingFees, setIsCollectingFees] = useState(false)
    const [isRemoveLiquidity, setIsRemoveLiquidity] = useState(false)
    const [isAddLiquidity, setIsAddLiquidity] = useState(false)
    const getPrice = useStoreState((state) => state.pricing.getPrice)
    const loadTransaction = useStoreActions((actions) => actions.transaction.loadTransaction)
    const [txHash, setTxHash] = useState('')
    const [currentTick, setCurrentTick] = useState('')
    const transaction = useStoreState((state) => state.transaction.getTransaction(txHash))
    const loadPositons = useStoreActions((actions) => actions.clPools.loadPositons)
    // const [intervalId, setIntervalId] = useState(undefined as unknown as NodeJS.Timeout)
    const [isRebalanceOpen, setIsRebalanceOpen] = useState(false)
    const [isLoadingPage, setIsLoadingPage] = useState(true)
    const [isWrongNetwork, setIsWrongNetwork] = useState(false)
    const [isOutOfRange, setIsOutOfRange] = useState(false)
    const [unclaimedAPR, setUnclaimedAPR] = useState<string>('')
    const navigate = useNavigate()
    const [apr, setApr] = useState<string>('')

    const previousWalletAddress = usePrevious(connectedAddress)

    // useEffect(() => {
    //     connect(true)
    //     // if (!connectedAddress) connect(true)
    // }, [])

    useEffect(() => {
        if (connectedAddress && searchParams && searchParams.get('walletAddress') && searchParams.get('walletAddress') !== connectedAddress) return setIsWrongNetwork(true)
    }, [connectedAddress])

    useEffect(() => {
        updateIsOutOfRange()
    }, [currentRatio, clPosition])

    useEffect(() => {
        console.log('LOADED TICK + CURRENT_RATIO ' + new Date())
        updateCurrentTickRatio()
        const interval = setInterval(() => {
            console.log('LOADED TICK + CURRENT_RATIO ' + new Date())
            updateCurrentTickRatio()
            onLoadPostions(false, positionIndex)
        }, 20000)

        console.log('intervalintervalinterval ', interval)
        // setIntervalId(interval)

        return () => {
            console.log('CLEARING! ', interval)
            clearInterval(interval)
        }
    }, [selectedPool])

    useEffect(() => {
        if (searchParams.get('positionIndex')) setPositionIndex(Number(searchParams.get('positionIndex')))
    }, [searchParams])

    useEffect(() => {
        if (!clPosition) return
        const token1 = getToken(network!, clPosition?.token0!)
        const token2 = getToken(network!, clPosition?.token1!)
        if (isRange1 === undefined) {
            if (token1?.symbol === 'ETH') {
                setIsRange1(true)
            } else if (token2?.symbol === 'ETH') {
                setIsRange1(false)
            } else {
                setIsRange1(true)
            }
        }
    }, [clPosition])

    useEffect(() => {
        if (connectedAddress && positionIndex) onLoadPostions(true, positionIndex)
    }, [connectedAddress, positionIndex])

    function updateIsOutOfRange() {
        if (!clPosition || !currentTick) return
        const isOutOfRange = Number(currentTick) > clPosition.tickUpper - MAX_TICK || Number(currentTick) < clPosition.tickLower - MAX_TICK

        setIsOutOfRange(isOutOfRange)
    }

    async function onLoadPostions(isStartLoading = true, selectedPositionIndex?: number) {
        if (isStartLoading) setIsLoadingPage(true)
        try {
            const res = await loadPositons({
                network: network as Network,
                address: connectedAddress!,
                selectedPosition: selectedPositionIndex !== undefined && selectedPositionIndex !== -1 ? selectedPositionIndex : -1
            })
            // loadLegacyPositons({ network: network as Network })
            setIsLoadingPage(false)
        } catch (e: any) {
            setIsLoadingPage(false)
        }
    }

    useEffect(() => {
        if (previousWalletAddress && previousWalletAddress !== connectedAddress) () => navigate('/positions')
    }, [connectedAddress])

    useEffect(() => {
        if (network === 'mainnet-alpha') GAtrack('route_position', 'route_position', 'position', -1)
    }, [])

    useEffect(() => {
        setApr('')
        setUnclaimedAPR('')
        if (network) {
            fetchApr()
        }
    }, [clPosition])

    async function fetchApr() {
        if (clPosition && clPosition.positionIndex > 0) {
            try {
                const aprData = await (await fetch(`${apiUrl(network ?? '')}/cl/nft_apr?token_id=${clPosition?.positionIndex}&ver=1`)).json()
                if (typeof aprData['gain_percent_usd'] === 'string') {
                    setApr(aprData['gain_percent_usd'])
                } else {
                    setApr(`${(Number(aprData['gain_percent_usd']) * 100).toFixed(2)}%`)
                }
                const apr = BigNumber(aprData['apr']).multipliedBy(100)
                if (apr.gte(1000)) {
                    setUnclaimedAPR(`${apr.toFixed(0)}%`)
                } else if (apr.eq(0)) {
                    setUnclaimedAPR('0%')
                } else if (apr.lte(0.01)) {
                    setUnclaimedAPR('<0.01%')
                } else {
                    setUnclaimedAPR(`${apr.toPrecision(4)}%`)
                }
            } catch (e) {
                setApr('N/A')
                setUnclaimedAPR('')
            }
        }
    }

    async function loadPoolsData() {
        await getAllCLPools(network as Network, getToken(network as Network, clPosition?.token0!)!, getToken(network as Network, clPosition?.token1!)!)
        const pool = getCLPool(network as Network, getToken(network as Network, clPosition?.token0!)!, getToken(network as Network, clPosition?.token1!)!, clPosition?.fee!)
        if (pool) setSelectedPool(pool)
        else setSelectedPool(undefined as unknown as CLPool)
    }

    useEffect(() => {
        if (transaction && (transaction.status === 'ACCEPTED_ON_L2' || transaction.status === 'ACCEPTED_ON_L1')) {
            setTxHash('')
            loadPositons({ network: network as Network, address: connectedAddress!, selectedPosition: positionIndex })
            // loadBalances({ network: network, walletAddress: connectedAddress })
            // ({ network, amountOfPools: numOfPools, walletAddress: connectedAddress })
        }
    }, [transaction])

    useEffect(() => {
        if (currentRatio) getPercentageOfLiquidity()
    }, [currentRatio])

    useEffect(() => {
        if (clPosition) loadPoolsData()
    }, [clPosition])

    // useEffect(() => {
    //     if (selectedPool) loadCurrentTick()
    // }, [selectedPool])

    async function updateCurrentTickRatio() {
        if (!selectedPool) return
        const tick = await getCurrentTick(network as Network, selectedPool.address)
        setCurrentTick(tick)
        try {
            const ratio = await getCurrentRatio(network as Network, selectedPool.address)
            setCurrentRatio(ratio)
        } catch (e) {}
    }

    // async function loadCurrentTick() {
    //     if (intervalId) clearInterval(intervalId)
    //     console.log('LOADED TICK + CURRENT_RATIO ' + new Date())
    //     updateCurrentTickRatio()
    //     const interval = setInterval(() => {
    //         console.log('LOADED TICK + CURRENT_RATIO ' + new Date())
    //         updateCurrentTickRatio()
    //     }, 5000)

    //     console.log('intervalintervalinterval ', interval)
    //     setIntervalId(interval)
    // }

    async function onCollectFees() {
        if (!clPosition) return

        setIsCollectingFees(true)
        try {
            const response = await collectFees(
                network as Network,
                {
                    fee: clPosition!.fee!,
                    feeGrowthInside0LastX128: clPosition!.feeGrowthInside0LastX128!,
                    feeGrowthInside1LastX128: clPosition!.feeGrowthInside1LastX128!,
                    liquidity: clPosition?.liquidity,
                    positionIndex: clPosition?.positionIndex,
                    tickLower: clPosition?.tickLower,
                    tickUpper: clPosition?.tickUpper,
                    token0: clPosition?.token0,
                    token1: clPosition?.token1,
                    tokensOwed0: clPosition?.tokensOwed0,
                    tokensOwed1: clPosition?.tokensOwed1
                },
                false,
                clPosition?.fees?.token1Amount!,
                clPosition?.fees?.token2Amount!
            )
            if (network === 'mainnet-alpha') GAtrack('tx_initiated_collect_fees', 'tx_initiated_collect_fees', 'collect_fees')
            const timestampSent = new Date().getTime()

            // @ts-ignore
            if (response && response.tx) {
                // @ts-ignore
                loadTransaction({ txPayload: { [response.tx.hash]: { ...response.tx, labelFields: { timestampSent: timestampSent } } }, isGoogleLog: network === 'mainnet-alpha' })
                // @ts-ignore
                setTxHash(response.tx.hash)
                // @ts-ignore
                // GAtrack('NewTx', 'collect_fees', response.tx.hash)
                const label = `Claim fees token1Address = ${clPosition?.token0} token2Address = ${clPosition?.token1}`
                if (network === 'mainnet-alpha') GAtrack('tx_sent_collect_fees', 'tx_sent_collect_fees', label)
            }
            setIsCollectingFees(false)
        } catch (err) {
            setIsCollectingFees(false)
        }
    }

    function calculatePrincipalLiquidityUsd() {
        return calculateTotalLiquidityUsdPerPosition(clPosition, network as Network, true)
    }
    function calculateTotalLiquidityUsd() {
        return calculateTotalLiquidityUsdPerPosition(clPosition, network as Network, false)
    }
    function calculateTotalUnclaimedFees() {
        if (!clPosition || !clPosition.value) return '0'

        const token1Amount = Number(clPosition?.fees?.token1Amount!)
        const token2Amount = Number(clPosition?.fees?.token2Amount!)
        const token1 = getToken(network!, clPosition?.token0!)
        const token2 = getToken(network!, clPosition?.token1!)
        const token1Name = getTokenBraavosName(token1?.symbol!)
        const token2Name = getTokenBraavosName(token2?.symbol!)
        const token1Price = getPrice(token1Name) ? getPrice(token1Name).usd : 0
        const token2Price = getPrice(token2Name) ? getPrice(token2Name).usd : 0

        return (token1Price * token1Amount + token2Price * token2Amount).toFixed(10)
    }

    function getPercentageOfLiquidity() {
        return getPercentageOfLiquidityForPosition(currentRatio, clPosition)
    }

    function renderRebalancePopup() {
        return <RebalancePopup isOpen={isRebalanceOpen} onClose={() => setIsRebalanceOpen(false)} positionIndex={positionIndex} />
    }

    function renderRebalanceButton(position?: CLPosition, isMobile = false) {
        //if (network !== 'goerli-alpha') return null
        if (!position) return null
        // const isOutOfRange = position.poolCurrentTick > position.tickUpper || position.poolCurrentTick < position.tickLower
        if (!isOutOfRange) return null

        return (
            <PrimaryButton
                onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    setIsRebalanceOpen(true)
                }}
                className={`${isMobile ? 'mt-4 lg:hidden' : 'hidden lg:flex ml-3'}`}
                size='sm'>
                <span className='text-[18px]'>Rebalance</span>
            </PrimaryButton>
        )
    }

    function renderInOutRange(position: CLPosition) {
        // const isOutOfRange = position.poolCurrentTick > position.tickUpper || position.poolCurrentTick < position.tickLower
        if (!isOutOfRange) return null
        return (
            <div className={`flex items-center text-[#${isOutOfRange ? 'FFBC6C' : '68F2B0'}] text-[12px] flex-shrink-0 ml-4`}>
                {isOutOfRange ? <AlertIcon className='w-[16px] h-[16px]' /> : <HelptipIcon className='w-[16px] h-[16px]' />}
                <span className='ml-1'>{isOutOfRange ? 'Out Of Range' : 'In Range'}</span>
                <CircleIcon className='w-[6px] h-[6px] ml-1' />
                {renderRebalanceButton(position)}
            </div>
        )
    }

    function renderHeader() {
        if (!clPosition) return null
        const token1 = getToken(network!, clPosition.token0)!
        const token2 = getToken(network!, clPosition.token1)!

        return (
            <div className='w-full flex justify-between'>
                <div className='flex items-center'>
                    <div>
                        <img src={token1.icon} alt='' width={24} height={24} />
                    </div>
                    <div className='relative left-[-10px]'>
                        <img src={token2.icon} alt='' width={24} height={24} />
                    </div>
                    <span className='text-white font-bold text-[24px]'>{`${token1!.symbol} / ${token2?.symbol}`}</span>
                    <div className='bg-[#0C3F6D] p-1 rounded-[8px] text-[#0AE8F9] text-[16px] text-center ml-2'>{`${clPosition.fee / 10000}%`}</div>
                </div>
                {renderInOutRange(clPosition)}
            </div>
        )
    }

    function renderLiquidityLine(tokenAddress: string, amount: string, isToken1: boolean, isShowPercentage: boolean) {
        const token = getToken(network!, tokenAddress)
        return (
            <div className='flex justify-between mt-4'>
                <div className='flex items-center text-white'>
                    <img className='mr-1' width={24} height={24} src={token?.icon!} />
                    <span className='text-[16px]'>{token?.symbol}</span>
                </div>
                <div className=''>
                    <span>{formatFloatingPointNumber(amount)}</span>
                    {isShowPercentage ? (
                        <span className='ml-3 bg-[#0C3F6D] p-1 rounded-[8px] text-[#0AE8F9] text-[16px]'>
                            {isToken1 ? getPercentageOfLiquidity().percentage1 : getPercentageOfLiquidity().percentage2}%
                        </span>
                    ) : null}
                </div>
            </div>
        )
    }

    function renderLiquidityDetails() {
        if (!clPosition) return null

        // we want the position value without the fees.
        // so we have to reduce the fees from the position value we got
        const token1ValueBn = BigNumber(clPosition?.value && clPosition?.value.token1Amount ? clPosition?.value.token1Amount : 0)
        const token2ValueBn = BigNumber(clPosition?.value && clPosition?.value.token2Amount ? clPosition?.value.token2Amount : 0)
        const token1FeesBn = BigNumber(clPosition?.fees?.token1Amount! ?? 0)
        const token2FeesBn = BigNumber(clPosition?.fees?.token2Amount! ?? 0)
        let token1Value = token1ValueBn.minus(token1FeesBn)
        let token2Value = token2ValueBn.minus(token2FeesBn)

        // console.log('YSYS token1Value=', token1Value, ' token1ValueBn=', token1ValueBn)
        // console.log('YSYS token2Value=', token2Value, ' token2ValueBn=', token2ValueBn)

        // for safety - we make sure we dont get negative values here
        if (token1Value.isLessThan(0)) {
            token1Value = BigNumber(0)
        }
        if (token2Value.isLessThan(0)) {
            token2Value = BigNumber(0)
        }

        return (
            <div className='bg-[#0C1647] w-full flex flex-col p-4 rounded-[16px] text-white' style={{ boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                <span className='text-[16px]'>Liquidity</span>
                <span className='text-[24px] font-bold mt-6 block'>{`$${formatNumber(Number(calculatePrincipalLiquidityUsd()))}`}</span>
                {renderLiquidityLine(clPosition?.token0!, token1Value.toFixed(), true, true)}
                {renderLiquidityLine(clPosition?.token1!, token2Value.toFixed(), false, true)}
            </div>
        )
    }

    function renderUnclaimedFees() {
        const isNoFee = Number(clPosition?.fees?.token1Amount) === 0 && Number(clPosition?.fees?.token2Amount) === 0

        return (
            <div className='mt-4 lg:mt-0 bg-[#0C1647] w-full flex flex-col p-4 rounded-[16px] text-white' style={{ boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                <div className='relative flex items-center justify-between'>
                    <span className='text-[16px]'>Unclaimed fees</span>
                    <PrimaryButton
                        isLoading={isCollectingFees}
                        isDisabled={isCollectingFees || isNoFee}
                        theme='border'
                        onClick={onCollectFees}
                        size='sm'
                        className='absolute right-0 top-[-4px] text-white text-[16px] px-4 py-2 border-[1px] border-[#0C3F6D] rounded-[8px] text-center'>
                        <div className='text-[16px]'>Collect fees</div>
                    </PrimaryButton>
                </div>
                <div className='flex w-full items-center mt-6 justify-between'>
                    <span className='text-[24px] font-bold block'>{`$${formatNumber(Number(calculateTotalUnclaimedFees()))}`}</span>
                    {unclaimedAPR && (
                        <div className='flex items-center'>
                            <span className='text-white text-[14px]'>Fee APR:</span>
                            <div className='relative right-0 top-0 ml-2 group inline-flex'>
                                <span className='select-none text-[16px] text-[#0AE8F9] ml-1'>{unclaimedAPR}</span>
                                <span className='left-[auto] right-0 lg:left-[-250px] bottom-[-100px] w-[250px] group-hover:visible invisible group-hover:opacity-100 transition-opacity bg-[#242C58] text-sm text-gray-100 rounded-md absolute opacity-0  p-3 z-[1]'>
                                    {`The Annualized Percentage Revenue (APR) is calculated by annualizing the yield, which is the current Unclaimed Fee value in USD relative to the initial USD value at the time of providing liquidity.`}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                {renderLiquidityLine(clPosition?.token0!, clPosition?.fees?.token1Amount!, true, false)}
                {renderLiquidityLine(clPosition?.token1!, clPosition?.fees?.token2Amount!, false, false)}
            </div>
        )
    }

    function renderRangeSelector() {
        const token1 = getToken(network!, clPosition?.token0!)
        const token2 = getToken(network!, clPosition?.token1!)

        return (
            <div className='bg-[#0C2960] shadow-xl rounded-[8px] p-1 '>
                <span onClick={() => setIsRange1(true)} className={`cursor-pointer p-1 rounded-[8px] ${isRange1 ? 'bg-[#0AE8F9] text-[#0D0C1E]' : ''}`}>
                    {token1?.symbol}
                </span>
                <span onClick={() => setIsRange1(false)} className={`cursor-pointer p-1 rounded-[8px] ${!isRange1 ? 'bg-[#0AE8F9] text-[#0D0C1E]' : ''}`}>
                    {token2?.symbol}
                </span>
            </div>
        )
    }

    function renderMinPrice(isMin = true, isCurrent = false) {
        const pool_token0 = getToken(network!, clPosition?.token0!)
        const pool_token1 = getToken(network!, clPosition?.token1!)
        const token = isRange1 ? pool_token0 : pool_token1
        const token2 = isRange1 ? pool_token1 : pool_token0
        let ratio: BigNumber = BigNumber(1)
        if (pool_token0 !== undefined && pool_token1 !== undefined) {
            ratio = isMin
                ? calculateRatioFromTickForTokens(clPosition?.tickLower! - MAX_TICK, pool_token0, pool_token1)
                : calculateRatioFromTickForTokens(clPosition?.tickUpper! - MAX_TICK, pool_token0, pool_token1)

            if (!isRange1) ratio = BigNumber(1).dividedBy(ratio)
            if (isCurrent) {
                ratio = normalizeForTokens(BigNumber(Number(currentRatio)), pool_token0!, pool_token1!)
                if (!isRange1) ratio = BigNumber(1).div(ratio)
            }
        }

        let text = isMin ? 'Min' : 'Max'
        if (isCurrent) text = 'Current'
        return (
            <div
                className='bg-[#0C1647] text-center flex items-center text-white flex flex-col p-4 rounded-[16px] text-white'
                style={{ boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                <span className='text-[16px]'>{`${text} Price`}</span>
                <span className={`text-[24px] font-bold mt-2 w-full overflow-auto ${isCurrent ? 'text-[#0AE8F9]' : 'text-white'}`}>{`${
                    ratio.toNumber() > 1000 ? formatFloatingPointNumber(ratio.toNumber()) : formatFloatingPointNumber(ratio.toString())
                }`}</span>
                {/* <span className='text-[24px] font-bold mt-2 w-full overflow-auto'>{`${numFormat(ratio.toString())}`}</span> */}
                <div className='flex text-[16px] items-center'>
                    <span>{`${token2?.symbol}`}</span>
                    <span className='text-[12px] mx-1'>{`Per`}</span>
                    <span>{`${token?.symbol}`}</span>
                </div>
            </div>
        )
    }

    function renderPriceRange() {
        return (
            <div className='w-full mt-6 flex flex-col'>
                <div className='flex justify-between items-center'>
                    <span className='font-bold text-white text-[16px]'>Price Range</span>
                    {renderRangeSelector()}
                </div>
                <div className='flex mt-4 lg:flex-row flex-col'>
                    <div className='flex-1 mt-4 lg:mt-0 lg:mr-4 overflow-auto'>{isRange1 ? renderMinPrice(false, true) : renderMinPrice(true, true)}</div>
                    <div className='flex-1 mt-4 lg:mt-0 lg:mr-4 overflow-auto'>{isRange1 ? renderMinPrice() : renderMinPrice(false)}</div>
                    <div className='flex-1 mt-4 lg:mt-0 overflow-auto'>{isRange1 ? renderMinPrice(false) : renderMinPrice()}</div>
                </div>
            </div>
        )
    }

    function renderTotalsAndApr() {
        return (
            <div className='mt-6' style={{ display: 'flex' }}>
                <div
                    className='bg-[#0C1647] text-center flex items-center text-white flex flex-col p-4 rounded-[16px] text-white mr-4'
                    style={{ flex: 1, boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                    <span className='text-[16px]'>Total Value</span>
                    <span className='text-[24px] font-bold block'>{`$${formatNumber(Number(calculateTotalLiquidityUsd()))}`}</span>
                </div>

                <div
                    className='bg-[#0C1647] text-center flex items-center text-white flex flex-col p-4 rounded-[16px] text-white'
                    style={{ flex: 1, boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)' }}>
                    {
                        <div className='w-full flex flex-col items-center'>
                            <div className='flex items-center justify-center w-full relative'>
                                <div className='absolute right-0 top-0 ml-2 group inline-flex'>
                                    <HelptipIcon className='w-5 h-5 text-[#6F6E8F]' />
                                    <span className='right-0 left-[auto] lg:left-[-250px] bottom-[-100px] w-[250px] group-hover:visible invisible group-hover:opacity-100 transition-opacity bg-[#242C58] text-sm text-gray-100 rounded-md absolute opacity-0  p-3 z-[1]'>
                                        {`The percentage change calculated by comparing the USD value at the time of deposit to the current USD value of the position.`}
                                    </span>
                                </div>
                                <span className='text-[16px]'>Overall Change</span>
                            </div>
                            {apr ? (
                                <span className={`text-[${apr.length > 15 ? '12px' : '24px'}] ${apr.length > 15 ? 'font-bold' : ''} block`}>{apr}</span>
                            ) : (
                                <Spinner className='mt-2' />
                            )}
                        </div>
                    }
                </div>
            </div>
        )
    }

    function renderDetails() {
        return (
            <div className='flex flex-col lg:flex-row justify-between mt-6'>
                <div className='flex-1 lg:mr-4'>{renderLiquidityDetails()}</div>
                <div className='flex-1'>{renderUnclaimedFees()}</div>
            </div>
        )
    }

    function renderBack(onClick: () => void) {
        return (
            <div className='flex items-center lg:mb-6 mb-3'>
                <div className='cursor-pointer text-[#0AE8F9] flex flex-row' onClick={onClick}>
                    <BackIcon className='w-5 h-5 mr-2' />
                    <span>Back</span>
                </div>
            </div>
        )
    }

    function renderRemoveLiquidity() {
        let token1_obj = getToken(network!, clPosition?.token0!)!
        let token2_obj = getToken(network!, clPosition?.token1!)!

        return (
            <div>
                {renderBack(() => setIsRemoveLiquidity(false))}
                <RemoveLiquidity
                    onBackToPositions={() => navigate('/positions')}
                    onBackClick={() => setIsRemoveLiquidity(false)}
                    positionReduxIndex={positionIndex}
                    balance='2'
                    token1Amount='1'
                    token2Amount='2'
                    poolAddress={selectedPool.address}
                    token1Address={token1_obj ? token1_obj.address : ''}
                    token2Address={token2_obj ? token2_obj.address : ''}
                />
            </div>
        )
    }

    function renderAddLiquidity() {
        let token1_obj = getToken(network!, clPosition?.token0!)!
        let token2_obj = getToken(network!, clPosition?.token1!)!

        return (
            <div>
                {renderBack(() => setIsAddLiquidity(false))}
                <AddLiquidity
                    onBackClick={() => {
                        setIsAddLiquidity(false)
                    }}
                    currentTick={Number(currentTick)}
                    currentRatio={currentRatio.toString()}
                    positionReduxIndex={positionIndex}
                    // balance='2'
                    token1Amount='0'
                    token2Amount='0'
                    poolAddress={selectedPool.address}
                    token1Address={token1_obj.address}
                    token2Address={token2_obj.address}
                />
            </div>
        )
    }

    function getTickAmount() {
        if (!selectedPool) return 0
        if (selectedPool.fee / 1000 === 0.01) return 2
        if (selectedPool.fee / 10000 === 0.05) return 10
        else if (selectedPool.fee / 10000 > 0.05 && selectedPool.fee / 10000 <= 0.3) return 60
        return 200
    }

    function renderLoadingChart() {
        return (
            <div className='mt-4 flex items-center justify-center'>
                <div className='flex flex-col'>
                    <span className='mb-4 block'>Loading liquidity chart</span>
                    <Spinner />
                </div>
            </div>
        )
    }

    function renderRangeSelectorChart() {
        if (!selectedPool || !clPosition || !currentTick || !currentRatio || currentRatio === '0') return renderLoadingChart()
        const tickAmount = getTickAmount()
        const { maxMultiplier, minDivider } = getFeeMultiplierDivider(selectedPool.fee / 10000)

        const token1Obj = selectedPool.token1
        const token2Obj = selectedPool.token2
        let _currentPrice = normalizeForTokens(BigNumber(currentRatio), token1Obj!, token2Obj!)
        const currentPrice = numFormat(_currentPrice.toString())

        return (
            <div className='mt-[80px]'>
                <RangeSliderSelector
                    isReversed={isRange1}
                    isViewOnly={true}
                    // defaultZoomLevel={4}
                    currentRatio={Number(currentRatio)}
                    currentTick={Number(currentTick)}
                    maxTick={clPosition.tickUpper - MAX_TICK}
                    minTick={clPosition.tickLower - MAX_TICK}
                    poolId={selectedPool.address}
                    onUpdateMaxTick={() => {}}
                    onUpdateMinTick={() => {}}
                    tickAmount={tickAmount}
                    minDivider={minDivider}
                    maxMultiplier={maxMultiplier}
                    currentPrice={Number(isRange1 ? currentPrice : 1 / Number(currentPrice))}
                />
            </div>
        )
    }
    function renderContent() {
        if (isLoadingPage)
            return (
                <div className='mt-[32px] flex items-center justify-center flex-col'>
                    <span className='text-[24px] font-bold mb-4'>Loading position...</span>
                    <Spinner height='32px' width='32px' />
                </div>
            )
        if (isRemoveLiquidity) return renderRemoveLiquidity()
        if (isAddLiquidity) return renderAddLiquidity()

        return (
            <>
                <div className='flex flex-col w-full'>
                    {renderBack(() => navigate('/positions'))}

                    {renderHeader()}
                    {renderRebalanceButton(clPosition, true)}
                    <div className='w-full bg-[#0C3F6D] h-[1px] w-full mt-6' />
                </div>
                {renderTotalsAndApr()}
                {renderDetails()}
                {renderPriceRange()}
                <PrimaryButton size='lg' theme='bordered' onClick={() => setIsRemoveLiquidity(true)} className='mt-6'>
                    <span className='text-white '>Remove Liquidity</span>
                </PrimaryButton>
                <PrimaryButton
                    size='lg'
                    onClick={() => setIsAddLiquidity(true)}
                    className='bg-[#0C1647] border-[1px] border-[#0C3F6D] w-full py-2 cursor-pointer flex items-center justify-center mt-2 px-2 rounded-[16px]'>
                    <span>Add Liquidity</span>
                </PrimaryButton>
                {renderRebalancePopup()}
                {/* {renderRangeSelectorChart()} */}
            </>
        )
    }
    function renderWrongNetworkAccount() {
        if (!isWrongNetwork) return null

        return (
            <Popup open={isWrongNetwork} onClose={() => setIsWrongNetwork(false)}>
                <div>Switch network / account and refresh</div>
            </Popup>
        )
    }
    return (
        <div className='h-full relative pb-[48px] lg:pb-0'>
            <div className='lg:pt-6 max-w-[98%] m-auto'>
                <Header className='' selectedTab={'pools'} />
            </div>
            <div className={`pb-[65px] container w-full p-4 mx-auto`}>
                <div className='relative flex flex-col w-full m-auto max-w-[710px]'>{renderContent()}</div>
            </div>
            <Footer selectedTab={'pools'} />
            <div style={pageStyle} className={`hidden lg:flex z-0 absolute h-full w-full bg-[#00176A] pointer-events-none`} />
            <div style={pageStyleMobile} className={`lg:hidden z-0 absolute h-full w-full bg-[#00176A] pointer-events-none`} />
            {renderWrongNetworkAccount()}
        </div>
    )
}

export default PositionPage
